<template>
    <div class="visits">
        <h2 class="profile__header">{{ $t('nav.records') }}</h2>
        <div class="visits__links">
            <router-link class="visits__link" :to="{name:'profile.visits.current.consultations'}">
              {{$t('visits.consultation')}}
                <template v-if="consultationsCurrentCount > 0">
                    <b class="link__badges">{{ consultationsCurrentCount }}</b>
                </template>
            </router-link>
            <router-link class="visits__link" :to="{name:'profile.visits.current.diagnostics'}">
              {{$t('visits.diagnostics')}}
                <template v-if="diagnosticsCurrentCount > 0">
                    <b class="link__badges">{{ diagnosticsCurrentCount }}</b>
                </template>
            </router-link>
        </div>
        <div class="row">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'visits-current',
        computed: {
            ...mapGetters([
                'consultationsCurrentCount',
                'diagnosticsCurrentCount',
            ]),
        },
    }
</script>
